import React from 'react';
import { Button, makeStyles, Theme } from '@material-ui/core';
import clsx from 'clsx';


interface DashboardSwitchProps {
    dahsboardName: string,
    setDahsboardName: any,
    patientTransportDashboardName: string,
    agedCareDashboardName: string
}

const useStyles = makeStyles(() => ({
    dashboardSwitchContainer: {
        display: 'flex',
        justifyContent: 'center',
        margin: '40px 0px',
    },
    dashboardSwitchBlock: {
        display: "inline-flex",
        marginRight: 25,
        border: "1px solid #02489D",
        borderRadius: 20,
        overflow: "hidden",
    },
    dashboardSwitch: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: 150,
        height: 32,
        fontSize: 14,
        fontWeight: 500,
        cursor: "pointer",
    },
    activeSwitch: {
        background: "#02489D"
    },
    inactiveSwitch: {
        background: "transparent"
    }
}));
const DashboardSwitch: React.FC<DashboardSwitchProps> = ({
    dahsboardName,
    setDahsboardName,
    patientTransportDashboardName,
    agedCareDashboardName
}) => {
    const classes = useStyles();
    const activeDashboardSwitch = clsx(classes.dashboardSwitch, classes.activeSwitch);
    const inactiveDashboardSwitch = clsx(classes.dashboardSwitch, classes.inactiveSwitch);
    return (
        <div className={classes.dashboardSwitchContainer}>
        <span className={classes.dashboardSwitchBlock}>
            <span
                onClick={() => setDahsboardName(patientTransportDashboardName)}
                className={dahsboardName === patientTransportDashboardName ?
                    activeDashboardSwitch : inactiveDashboardSwitch}>
                Patient Transport
            </span>
            <span
                onClick={() => setDahsboardName(agedCareDashboardName)}
                className={dahsboardName === agedCareDashboardName ?
                    activeDashboardSwitch : inactiveDashboardSwitch}>
                Medical Response
            </span>
        </span>
    </div>
    );
}

export default DashboardSwitch;